// Central helper for rendering people's names with a "Bro." / "Sis." title
// prefix based on their gender. Kept dead-simple so it works everywhere we
// currently show names (rosters, cards, detail headers, emails-in-toast, etc).
//
// Guests, disciples, users, household members etc. all follow the same shape:
//   { first_name, last_name, gender }  where gender is "male" | "female" | null.
//
// Usage:
//   import { formatDisplayName, titlePrefix } from "@/lib/names";
//   formatDisplayName(g)                 // "Bro. John Smith" | "Sis. Jane" | "John Smith"
//   formatDisplayName(g, { lastFirst })  // "Smith, Bro. John"
//   titlePrefix(g.gender)                // "Bro. " | "Sis. " | ""

export function titlePrefix(gender) {
  if (gender === "male") return "Bro. ";
  if (gender === "female") return "Sis. ";
  return "";
}

export function formatDisplayName(person, opts = {}) {
  if (!person) return "";
  let first = (person.first_name || "").trim();
  let last = (person.last_name || "").trim();
  // Fallback: some records (users, coordinators) only carry a single `name`
  // field. Split on the last space so "Cody D. Thrash" → first="Cody D.", last="Thrash".
  if (!first && !last && person.name) {
    const parts = String(person.name).trim().split(/\s+/);
    if (parts.length === 1) {
      first = parts[0];
    } else {
      first = parts.slice(0, -1).join(" ");
      last = parts[parts.length - 1];
    }
  }
  const prefix = titlePrefix(person.gender);
  if (opts.lastFirst) {
    // "Smith, Bro. John" — used in sort-by-last-name rosters.
    if (last && first) return `${last}, ${prefix}${first}`.trim();
    return `${prefix}${first || last}`.trim();
  }
  if (opts.firstOnly) return `${prefix}${first || last}`.trim();
  const combined = `${first} ${last}`.trim();
  return `${prefix}${combined}`.trim();
}

// For sorting comparisons — strips the title so "Sis." and "Bro." don't
// interleave everyone.
export function sortKey(person) {
  return `${(person?.last_name || "").toLowerCase()} ${(person?.first_name || "").toLowerCase()}`.trim();
}
